import httpClient from '@/http-client'

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/invoices/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/invoices-create-for-student-no-enrollments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export default {
  formViewModel,
  store
}
